
define('app/dashboard/leagues/create/lgCreateMain',[
	'domReady',
	'app/dashboard/leagues/create/lgCreateApp',
	'app/common/setup'
], function(domReady, LgCreateApp, Setup){
	domReady(function () {
		Setup.initialize();
		LgCreateApp.initialize();
    });
});